import { TipoAcompanhamentoEnum, TipoRegistroHistoricoClinico } from 'graphql/types.generated'

import {
  CIAPS_GESTACAO_CODIGOS,
  CIAPS_PUERPERIO_CODIGOS,
  CIDS_GESTACAO_CODIGOS,
  CIDS_PUERPERIO_CODIGOS,
} from '../../soap/pre-natal/model-preNatal'

interface FiltrosAcompanhamento {
  tiposRegistro: TipoRegistroHistoricoClinico[]
  codCiaps2: string[]
  codCids10: string[]
}

const FILTROS_CONSULTAS_POR_ACOMPANHAMENTO: Record<TipoAcompanhamentoEnum, FiltrosAcompanhamento> = {
  [TipoAcompanhamentoEnum.PRE_NATAL]: {
    tiposRegistro: [
      TipoRegistroHistoricoClinico.PRE_NATAL,
      TipoRegistroHistoricoClinico.CONSULTA,
      TipoRegistroHistoricoClinico.ATENDIMENTO_ODONTOLOGICO,
    ],
    codCiaps2: [...CIAPS_GESTACAO_CODIGOS],
    codCids10: [...CIDS_GESTACAO_CODIGOS],
  },
  [TipoAcompanhamentoEnum.PUERPERIO]: {
    tiposRegistro: [TipoRegistroHistoricoClinico.PUERPERIO, TipoRegistroHistoricoClinico.CONSULTA],
    codCiaps2: [...CIAPS_PUERPERIO_CODIGOS],
    codCids10: [...CIDS_PUERPERIO_CODIGOS],
  },
}

export const getFiltrosConsultasPorAcompanhamento = (tipo: TipoAcompanhamentoEnum): FiltrosAcompanhamento => {
  return FILTROS_CONSULTAS_POR_ACOMPANHAMENTO[tipo]
}
